import React, { forwardRef } from "react";
import moment from "moment";
import { GENDER_LABELS } from "../../../../constants/gender";
import neoLogo from "../../../../assets/images/Neo_Logo_A.svg";

const PrintableTestReport = forwardRef(({ event, results, tenantName, tenantLogo }, ref) => {
    const testTypeVal = event?.testType?.id || event?.testType;
    const testTypeLabel = typeof event?.testType?.label === 'string' ? event?.testType?.label : event?.testType;
    const isTimeBased = testTypeVal === "fixed_distance" || testTypeVal === "time";

    const dateStart = event?.startDate
        ? moment(event.startDate).format("DD/MM/YYYY")
        : "--";


    return (
        <div ref={ref} style={{ padding: "30px 40px", fontFamily: "'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif", color: "#333", backgroundColor: "#fff" }}>
            
            {/* ═══ CABEÇALHO ═══ */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid #eee", paddingBottom: "20px", marginBottom: "24px" }}>
                {/* ESQUERDA: Logo */}
                <div style={{ flex: "0 0 auto", minWidth: "120px" }}>
                    {tenantLogo && (
                        <img src={tenantLogo} alt="Logo" style={{ maxHeight: "70px", maxWidth: "160px", objectFit: "contain" }} />
                    )}
                </div>

                {/* DIREITA: Nome + Dados do Evento */}
                <div style={{ textAlign: "right", flex: "1 1 auto", paddingLeft: "15px" }}>
                    <h2 style={{ margin: "0 0 6px 0", fontSize: "14px", fontWeight: "700", color: "#555", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        {tenantName || "Empresa"}
                    </h2>
                    <h3 style={{ margin: "0 0 4px 0", fontSize: "18px", fontWeight: "700", color: "#111" }}>
                        {event?.name || "Ranking do Teste"}
                    </h3>

                    <p style={{ margin: "2px 0", fontSize: "13px", color: "#555" }}>
                        <strong>Data:</strong> {dateStart}
                    </p>
                    <p style={{ margin: "2px 0", fontSize: "13px", color: "#555" }}>
                        <strong>Formato:</strong> {testTypeVal === 'fixed_time' ? `Tempo Fixo (${event?.fixedTime} min)` : 
                         testTypeVal === 'fixed_distance' ? `Distância Fixa (${event?.fixedDistance} m)` : 
                         (typeof testTypeLabel === 'string' ? testTypeLabel : "Padrão")}
                    </p>
                </div>
            </div>

            {/* ═══ TABELA DE RESULTADOS ═══ */}
            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "24px", fontSize: "13px" }}>
                <thead>
                    <tr style={{ backgroundColor: "#212529", color: "#fff", textAlign: "left" }}>
                        <th style={{ padding: "10px 12px", fontWeight: "600", width: "5%", textAlign: "center" }}>Pos</th>
                        <th style={{ padding: "10px 12px", fontWeight: "600", width: "45%" }}>Atleta / Aluno</th>
                        <th style={{ padding: "10px 12px", fontWeight: "600", width: "15%", textAlign: "center" }}>Idade</th>
                        <th style={{ padding: "10px 12px", fontWeight: "600", width: "15%", textAlign: "center" }}>Sexo</th>
                        <th style={{ padding: "10px 12px", fontWeight: "600", width: "20%", textAlign: "center" }}>Resultado</th>
                    </tr>
                </thead>
                <tbody>
                    {(results || []).map((res, index) => {
                        const pos = index + 1;
                        const genderLabel = GENDER_LABELS[res.genderGroup] || res.genderGroup || '-';
                        
                        return (
                            <tr
                                key={res.id || index}
                                style={{
                                    borderBottom: "1px solid #dee2e6",
                                    backgroundColor: index % 2 === 0 ? "#fff" : "#f8f9fa"
                                }}
                            >
                                <td style={{ padding: "9px 12px", textAlign: "center", fontWeight: "600", color: "#888" }}>
                                    {pos}º
                                </td>
                                <td style={{ padding: "9px 12px", fontWeight: "600", color: "#111", textTransform: "uppercase", fontSize: "12px" }}>
                                    {res.fullName || "Desconhecido"}
                                </td>
                                <td style={{ padding: "9px 12px", color: "#555", textAlign: "center", fontSize: "12px" }}>
                                    {res.age ? `${res.age} anos` : '-'}
                                </td>
                                <td style={{ padding: "9px 12px", color: "#555", textAlign: "center", fontSize: "12px" }}>
                                    {genderLabel}
                                </td>
                                <td style={{ padding: "9px 12px", textAlign: "center", fontWeight: "700", color: "#333" }}>
                                    {isTimeBased ? res.resultTime : res.resultDistance}
                                </td>
                            </tr>
                        );
                    })}
                    {(!results || results.length === 0) && (
                        <tr>
                            <td colSpan="5" style={{ padding: "30px", textAlign: "center", color: "#888" }}>
                                Nenhum resultado registrado para este teste.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>


            {/* ═══ RODAPÉ ═══ */}
            <div style={{ marginTop: "40px", paddingTop: "20px", borderTop: "2px solid #eee" }}>
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
                    <div style={{ textAlign: "right" }}>
                        <p style={{ margin: "0 0 5px 0", fontSize: "11px", fontStyle: "italic", color: "#999" }}>
                            Gerado em {moment().format("DD/MM/YYYY [às] HH:mm")}.
                        </p>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "6px", marginTop: "8px" }}>
                            <span style={{ fontSize: "11px", fontWeight: "700", color: "#aaa", letterSpacing: "1px" }}>POWERED BY</span>
                            <img src={neoLogo} alt="NeoApp" style={{ height: "14px", filter: "grayscale(100%) opacity(0.6)" }} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default PrintableTestReport;
